import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { auth, db } from "../../../firebase";
import { doc, setDoc, writeBatch, collection } from "firebase/firestore";

import axios from "axios";

import Popup from '../../mobile/Popup';

import styleClasses from '../css/mobile/MyPage.module.scss';

const API_SERVER_URL = "https://music-api-134893551192.asia-northeast3.run.app/api/albums/youtube"; // 🔹 Cloud Run API URL
const SPOTIFY_API_SERVER_URL = "https://music-api-134893551192.asia-northeast3.run.app/api/albums/spotify";
const SOUNDCLOUD_API_SERVER_URL = "https://music-api-134893551192.asia-northeast3.run.app/api/albums/soundcloud";

function ImportAlbumPopup({ open, setOpenPopup, fetchAlbums }) {
  // URL 파라미터에서 attribute 값을 읽음 (예: released, unreleased)
  const { attribute } = useParams();
  const isReleased = attribute === "released";
  const isUnreleased = attribute === "unreleased";

  // released인 경우에는 기존 YouTube, Spotify 옵션을 사용
  // unreleased인 경우에는 SoundCloud 옵션만 사용
  const [checkedYouTube, setCheckedYouTube] = useState(isReleased ? true : false);
  const [checkedSpotify, setCheckedSpotify] = useState(false);
  const [checkedUnreleasedYouTube, setCheckedUnreleasedYouTube] = useState(isUnreleased ? true : false);
  const [checkedSoundCloud, setCheckedSoundCloud] = useState(false);

  const [active, setActive]                 = useState(open ? styleClasses.active : '');
  const [uid, setUid]                       = useState(null);
  const [showProgress, setShowProgress]     = useState(false);
  const [progress, setProgress]             = useState(0);
  
  const youTubeRef  = useRef();
  const spotifyRef  = useRef();
  const soundCloudRef = useRef();
  const unreleasedPlaylistRef = useRef();
  const unreleasedVideoRef = useRef();

  //const [checkedYouTube, setCheckedYouTube] = useState(true);
  const [youTubeKeyword, setYouTubeKeyword]   = useState('');
  const [loadingYouTube, setLoadingYouTube]   = useState(false);

  //const [checkedSpotify, setCheckedSpotify] = useState(false);
  const [spotifyKeyword, setSpotifyKeyword] = useState('');
  const [loadingSpotify, setLoadingSpotify] = useState(false);

  const [soundCloudKeyword, setSoundCloudKeyword] = useState('');
  const [loadingSoundCloud, setLoadingSoundCloud] = useState(false);

  const [unreleasedYouTubeKeyword1, setUnreleasedYouTubeKeyword1] = useState('');
  const [unreleasedYouTubeKeyword2, setUnreleasedYouTubeKeyword2] = useState('');
  const [loadingUnreleasedYouTube1, setLoadingUnreleasedYouTube1] = useState(false);
  const [loadingUnreleasedYouTube2, setLoadingUnreleasedYouTube2] = useState(false);

  const [showAlbumList, setShowAlbumList]   = useState(false);
  const [channelUrl, setChannelUrl]         = useState(""); // 채널 URL 입력값
  const [artistUrl, setArtistUrl]           = useState("");   // 스포티파이 아티스트 URL 입력값
  const [soundCloudUrl, setSoundCloudUrl]   = useState("");
  const [playlistUrl, setPlaylistUrl]       = useState("");
  const [videoUrl, setVideoUrl]             = useState("");

  const [albums, setAlbums]                 = useState([]);
  const [pushAlbums, setPushAlbums]         = useState([]);
  const [loading, setLoading]               = useState(false);
  const [authToken, setAuthToken]           = useState(""); // 🔹 Firebase Auth JWT 토큰 저장

  const [openInnerPopup, setOpenInnerPopup]   = useState(false);
  const [innerPopupTitle, setInnerPopupTitle] = useState('');
  const [innerPopupText, setInnerPopupText]   = useState('');

  // 🔹 팝업 열기/닫기
  useEffect(() => {
    setActive(open ? styleClasses.active : '');

    setShowProgress(false);
    setProgress(0);
    if (open) {
      if (isReleased) {
        setCheckedYouTube(true);
        setCheckedUnreleasedYouTube(false);
      } else {
        setCheckedYouTube(false);
        setCheckedUnreleasedYouTube(true);
      }
      setCheckedSpotify(false);
      setCheckedSoundCloud(false);
      setChannelUrl('');
      setArtistUrl('');
      setSoundCloudUrl('');
      setPlaylistUrl('');
      setVideoUrl('');
      setAlbums([]);
      setPushAlbums([]);
      setShowAlbumList(false);
    }
  }, [open, isReleased]);

  // 🔹 로그인 확인 후 JWT 조회
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUid(user.uid);
        const token = await user.getIdToken(); // 🔥 Firebase Auth JWT 토큰 가져오기
        setAuthToken(token);
      }
    });

    return () => unsubscribe();
  }, []);

  // 🔹 음원 링크 선택
  const showOption = (event) => {
    setPushAlbums([]);
    
    const option  = event.target.id;
    if (option === 'youtube') {
      setCheckedYouTube(true);
      setCheckedSpotify(false);
      setCheckedSoundCloud(false);
      setCheckedUnreleasedYouTube(false);
    } else if (option === 'spotify') {
      setCheckedYouTube(false);
      setCheckedSpotify(true);
      setCheckedSoundCloud(false);
      setCheckedUnreleasedYouTube(false);
    } else if (option === "unreleasedYouTube") {  // 대문자 Y 사용
      setCheckedYouTube(false);
      setCheckedSpotify(false);
      setCheckedSoundCloud(false);
      setCheckedUnreleasedYouTube(true);
    } else if (option === "soundcloud") {
      setCheckedYouTube(false);
      setCheckedSpotify(false);
      setCheckedSoundCloud(true);
      setCheckedUnreleasedYouTube(false);
    }
    setChannelUrl('');
    setArtistUrl('');
    setSoundCloudUrl('');
    setPlaylistUrl('');
    setVideoUrl('');
    setAlbums([]);
    setPushAlbums([]);
    setShowAlbumList(false);
  }

  // ✅ 유튜브에서 앨범 데이터 가져오기 (Cloud Run API 호출)
  const fetchAlbumsFromYouTube = async () => {
    setAlbums([]);
    setPushAlbums([]);
    setShowAlbumList(false);

    if (!channelUrl) {
      setYouTubeKeyword('error');
      youTubeRef.current.focus();
      return;
    }

    try {
      setLoadingYouTube(true);
      console.log("🎤 입력된 채널 URL:", channelUrl);

      // 🔹 Cloud Run API 호출
      const response = await axios.get(API_SERVER_URL, {
        params: { channelUrl }, // 🔹 API에 channelUrl 전달
        headers: {
          Authorization: `Bearer ${authToken}`, // 🔹 Firebase Auth 토큰 포함
        },
      });

      console.log("🎶 Cloud Run API 응답 데이터:", response.data);
      setAlbums(response.data.albums); // 🔥 API 응답에서 albums 데이터 설정
    } catch (error) {
      console.error("❌ Cloud Run API 호출 실패:", error);
      
      setOpenInnerPopup(true);
      setInnerPopupTitle('앨범 검색 중 오류가 발생했습니다.');
      setInnerPopupText('');
    } finally {
      setShowAlbumList(true);
      setLoadingYouTube(false);
    }
  };

  // ✅ 스포티파이 앨범 가져오기 함수
  const fetchAlbumsFromSpotify = async () => {
    setAlbums([]);
    setPushAlbums([]);
    setShowAlbumList(false);

    if (!artistUrl) {
      setSpotifyKeyword('error');
      spotifyRef.current.focus();
      return;
    }
    try {
      setLoadingSpotify(true);
      console.log("🎤 입력된 스포티파이 아티스트 URL:", artistUrl);
      const response = await axios.get(SPOTIFY_API_SERVER_URL, {
        params: { artistUrl },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log("🎶 스포티파이 API 응답 데이터:", response.data);
      setAlbums(response.data.albums);
    } catch (error) {
      console.error("❌ 스포티파이 API 호출 실패:", error);
      
      setOpenInnerPopup(true);
      setInnerPopupTitle('앨범 검색 중 오류가 발생했습니다.');
      setInnerPopupText('');
    } finally {
      setShowAlbumList(true);
      setLoadingSpotify(false);
    }
  };

  // ✅ 유튜브에서 미발매 앨범 or 음원 데이터 가져오기 (Cloud Run API 호출)
  const fetchUnreleasedAlbumsFromYouTube = async (type) => {
    setAlbums([]);
    setPushAlbums([]);
    setShowAlbumList(false);

    if (type === 1 && playlistUrl === '') {
      setUnreleasedYouTubeKeyword1('error');
      unreleasedPlaylistRef.current.focus();
      return false;
    } else if (type === 2 && videoUrl === '') {
      setUnreleasedYouTubeKeyword2('error');
      unreleasedVideoRef.current.focus();
      return false;
    }

    try {
      if (type === 1) {
        setLoadingUnreleasedYouTube1(true);
        setVideoUrl('');
        setUnreleasedYouTubeKeyword2('');
      } else if (type === 2) {
        setLoadingUnreleasedYouTube2(true);
        setPlaylistUrl('');
        setUnreleasedYouTubeKeyword1('');
      }

      let params = {};
      if (playlistUrl) {
        console.log("🎤 입력된 플레이리스트 URL:", playlistUrl);
        params.playlistUrl = playlistUrl;
      } else {
        console.log("🎤 입력된 동영상 URL:", videoUrl);
        params.videoUrl = videoUrl;
      }
  
      // API 호출: query parameter는 params 객체에 따라 playlistUrl 또는 videoUrl이 전송됩니다.
      const response = await axios.get(API_SERVER_URL, {
        params,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log("🎶 Cloud Run API 응답 데이터:", response.data);
      setAlbums(response.data.albums); // 🔥 API 응답에서 albums 데이터 설정
    } catch (error) {
      console.error("❌ Cloud Run API 호출 실패:", error);
      
      setOpenInnerPopup(true);
      setInnerPopupTitle('앨범 검색 중 오류가 발생했습니다.');
      setInnerPopupText('');
    } finally {
      setShowAlbumList(true);
      setLoadingUnreleasedYouTube1(false);
      setLoadingUnreleasedYouTube2(false);
    }
  };

  // SoundCloud 앨범 가져오기
  const fetchAlbumsFromSoundCloud = async () => {
    setAlbums([]);
    setPushAlbums([]);
    setShowAlbumList(false);

    if (!soundCloudUrl) {
      setSoundCloudKeyword('error');
      soundCloudRef.current.focus();
      return;
    }
    try {
      setLoadingSoundCloud(true);
      console.log("입력된 SoundCloud 사용자 URL:", soundCloudUrl);
      const response = await axios.get(SOUNDCLOUD_API_SERVER_URL, {
        params: { userUrl: soundCloudUrl },
        headers: { Authorization: `Bearer ${authToken}` },
      });
      console.log("SoundCloud API 응답 데이터:", response.data);
      setAlbums(response.data.albums);
    } catch (error) {
      console.error("SoundCloud API 호출 실패:", error);
      setOpenInnerPopup(true);
      setInnerPopupTitle("앨범 검색 중 오류가 발생했습니다.");
      setInnerPopupText("");
    } finally {
      setShowAlbumList(true);
      setLoadingSoundCloud(false);
    }
  };

  // 🔹 앨범 선택 (체크박스)
  const checkAlbum = (checked, album) => {
    setPushAlbums(prev => 
      checked 
        ? [...prev, album]
        : prev.filter(item => item.id !== album.id)
    );

    const safeAlbumCardClass = CSS.escape(styleClasses.albumCard);
    const allAlbums = document.querySelectorAll(`.${safeAlbumCardClass} input[name="eachAlbum"]`);
    const checkedAlbums = document.querySelectorAll(`.${safeAlbumCardClass} input[name="eachAlbum"]:checked`);
    const allCheckBox = document.getElementById("checkAllAlbums");
    if (allAlbums && allCheckBox) {
      allCheckBox.checked = allAlbums.length === checkedAlbums.length;
    }    
  }

  // 🔹 모든 앨범 선택/해제
  const checkAllAlbums  = (checked) => {
    const safeAlbumCardClass = CSS.escape(styleClasses.albumCard);
    const targetAlbums = document.querySelectorAll(`.${safeAlbumCardClass} input[name="eachAlbum"]`);

    if (targetAlbums.length) {
      if (checked) {
        targetAlbums.forEach(eachAlbum => eachAlbum.checked = true);
        setPushAlbums(albums);
      } else {
        targetAlbums.forEach(eachAlbum => eachAlbum.checked = false);
        setPushAlbums([]);
      }
    }
  }

  // ✅ Firestore에 앨범 추가 함수
  const handleAddAlbum = async () => {
    if (!uid) {
      setOpenInnerPopup(true);
      setInnerPopupTitle('로그인이 필요합니다.');
      setInnerPopupText('');
      return;
    }

    if (pushAlbums.length === 0) {
      setOpenInnerPopup(true);
      setInnerPopupTitle('앨범을 선택해주세요.');
      setInnerPopupText('');
      return;
    }

    try {
      setLoading(true);

      const albumTitles = [];

      let allItemsLength  = pushAlbums.length;
      let currentProgress = 1;
      if (allItemsLength > 2) {
        setShowProgress(true);
        setTimeout(() => {
          setProgress(((currentProgress / allItemsLength) * 100).toFixed(2));
        }, 100);
      }

      for (const album of pushAlbums) {
        const albumRef = doc(db, "users_data", uid, attribute, album.id.toString());
        const albumData = {
          cover: album.cover,
          title: album.title,
          year: album.year,
          artist: album.artist,
          description: album.description ?? '',
          createdAt: new Date().toISOString(),
        };
  
        await setDoc(albumRef, albumData);
  
        // 트랙 리스트 처리: 각 트랙에 번호를 붙임 (01, 02, …)
        const updatedTracks = (album.tracks || []).map((track, index) => ({
          id: (index + 1).toString().padStart(2, "0"),
          title: track.title,
          url: track.link,
          roles: track.credits && track.credits.length > 0 ? track.credits.join(", ") : ""
        }));
  
        // 트랙 정보를 하위 컬렉션 'tracks'에 저장 (writeBatch 사용)
        const batch = writeBatch(db);
        const tracksRef = collection(db, "users_data", uid, attribute, album.id.toString(), "tracks");
        updatedTracks.forEach((track) => {
          const trackDocRef = doc(tracksRef, track.id);
          batch.set(trackDocRef, track);
        });
        await batch.commit();

        albumTitles.push(`<p>"${album.title}" 앨범이 추가되었습니다.</p>`);

        if (allItemsLength > 2) {
          currentProgress++;
          const percent = currentProgress / allItemsLength * 100;
          if (percent === 100) {
            setProgress(99);  
          } else {
            setProgress(((currentProgress / allItemsLength) * 100).toFixed(2));
          }
        }
      }

      setShowProgress(false);
      setProgress(0);

      setLoading(false);
      setOpenInnerPopup(true);
      setInnerPopupTitle('아카이브에 추가되었습니다.');
      setInnerPopupText(albumTitles.join(''));

      const safeAlbumCardClass = CSS.escape(styleClasses.albumCard);
      const checkedAlbums = document.querySelectorAll(`.${ safeAlbumCardClass } input[name=eachAlbum]:checked`);
      const allCheckBox   = document.getElementById('checkAllAlbums');
      if (checkedAlbums) {
        checkedAlbums.forEach(element => element.checked = false);
      }
      if (allCheckBox) {
        allCheckBox.checked = false;
      }
      setPushAlbums([]);

      // fetchAlbums()가 정상적으로 전달되는지 확인
      if (typeof fetchAlbums === 'function') {
        fetchAlbums();
      }
    } catch (error) {
      console.error("앨범 저장 실패:", error);

      setShowProgress(false);
      setProgress(0);

      setLoading(false);
      setOpenInnerPopup(true);
      setInnerPopupTitle('앨범 추가 중 오류가 발생했습니다.');
      setInnerPopupText('');
    } 
  };

  return (
    <>
      <div className={`${ styleClasses.backDropMobile } ${ active }`} onClick={ () => { setActive(''); setOpenPopup(false); } }/>
      <div className={`${ styleClasses.importAlbumPopupMobile } ${ active }`}>
        <div className={ styleClasses.inner }>
          <div className={ styleClasses.header }>
            <div className={ styleClasses.title }>
              <h1>앨범 가져오기</h1>
            </div>
            <div className={ styleClasses.closeButton }>
              <button onClick={ () => { setActive(''); setOpenPopup(false); } }>
                <div className="commonIcon mobile">
                  <i className="closeWhite w32"></i>
                </div>
              </button>
            </div>
            <div className={ styleClasses.selectOption }>
              {isReleased && (
                <div className="commonForm">
                  <div className="formRow">
                    <div className="fieldBox checkBox">
                      <div className="eachBox">
                        <input type="radio" name="site" id="youtube" checked={ checkedYouTube } onChange={ showOption } />
                        <label htmlFor="youtube">YouTube</label>
                      </div>
                      <div className="eachBox">
                        <input type="radio" name="site" id="spotify" checked={ checkedSpotify } onChange={ showOption } />
                        <label htmlFor="spotify">Spotify</label>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {isUnreleased && (
                <div className="commonForm">
                  <div className="formRow">
                    <div className="fieldBox checkBox">
                      <div className="eachBox">
                        <input type="radio" name="site" id="unreleasedYouTube" checked={checkedUnreleasedYouTube} onChange={showOption} />
                        <label htmlFor="unreleasedYouTube">YouTube</label>
                      </div>
                      <div className="eachBox">
                        <input type="radio" name="site" id="soundcloud" checked={checkedSoundCloud} onChange={showOption} />
                        <label htmlFor="soundcloud">SoundCloud</label>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={`${ styleClasses.content }`}>
            {/* 유튜브 앨범 가져오기 섹션 */}
            {isReleased && (
              <div className={`${ styleClasses.searchBox } ${ checkedYouTube ? styleClasses.active : '' }`}>
                <div className={ styleClasses.description }>
                  <h2>유튜브 앨범 가져오기</h2>
                  <img 
                    src="/assets/images/YMimport.png" 
                    alt="유튜브 앨범 가져오기" 
                    style={{ maxWidth: '90%', height: 'auto', margin: '8px 0' }} 
                  />
                  <p>'아티스트명 - 주제(Topic)' 형태의 유튜브 채널 URL 혹은 유튜브 뮤직의 아티스트 공유 URL을 입력하시면 모든 앨범을 가져옵니다.</p>
                  <p>예) https://www.youtube.com/channel/[채널ID] 또는 https://music.youtube.com/channel/[채널ID]</p>
                </div>
                <div className={`commonForm ${ styleClasses.searchField }`}>
                  <div className="formRow">
                    <div className={`fieldBox ${ youTubeKeyword } ${ styleClasses.inputField }`}>
                      <input
                        type="text"
                        ref={ youTubeRef }
                        placeholder="유튜브 채널 URL 입력"
                        value={ channelUrl }
                        onChange={ (e) => { setChannelUrl(e.target.value); e.target.value !== '' && setYouTubeKeyword(''); } }
                      />
                      <div className="fieldError">
                        <p>유튜브 채널 URL을 입력하세요.</p>
                      </div>
                    </div>
                    <div className={`commonButton ${ styleClasses.searchButton }`}>
                      <button className="black" onClick={ fetchAlbumsFromYouTube } disabled={ loading }>
                        <div className="commonIcon mobile">
                          <i className="searchWhite w24"></i>
                        </div>
                        <div className={`buttonLoading ${ loadingYouTube && 'active' }`}>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 스포티파이 앨범 가져오기 섹션 */}
            {isReleased && (
              <div className={`${ styleClasses.searchBox } ${ checkedSpotify ? styleClasses.active : '' }`}>
                <div className={ styleClasses.description }>
                  <h2>스포티파이 앨범 가져오기</h2>
                  <p>스포티파이 아티스트 URL을 입력하면, 해당 아티스트의 모든 앨범을 가져옵니다.</p>
                  <p>예) https://open.spotify.com/artist/[아티스트ID]</p>
                </div>
                <div className={`commonForm ${ styleClasses.searchField }`}>
                  <div className="formRow">
                    <div className={`fieldBox ${ spotifyKeyword } ${ styleClasses.inputField }`}>
                      <input
                        type="text"
                        ref={ spotifyRef }
                        placeholder="스포티파이 아티스트 URL 입력"
                        value={ artistUrl }
                        onChange={ (e) => { setArtistUrl(e.target.value); e.target.value !== '' && setSpotifyKeyword(''); } }
                      />
                      <div className="fieldError">
                        <p>스포티파이 아티스트 URL을 입력하세요.</p>
                      </div>
                    </div>
                    <div className={`commonButton ${ styleClasses.searchButton }`}>
                      <button className="black" onClick={ fetchAlbumsFromSpotify } disabled={loading}>
                        <div className="commonIcon mobile">
                          <i className="searchWhite w24"></i>
                        </div>
                        <div className={`buttonLoading ${ loadingSpotify && 'active' }`}>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {/* 미발매 유튜브 앨범 및 음원 가져오기 섹션 */}
            {isUnreleased && (
            <div className={`${ styleClasses.searchBox } ${ checkedUnreleasedYouTube ? styleClasses.active : '' }`}>
                <div className={styleClasses.description}>
                  <h2>유튜브 플레이리스트 및 영상 가져오기</h2>
                  <p>플레이리스트 URL 혹은 영상 URL을 입력하세요.</p>
                  <p>
                    예) 플레이리스트: https://www.youtube.com/playlist?list=[플레이리스트ID]<br />
                    동영상: https://www.youtube.com/watch?v=[비디오ID]
                  </p>
                </div>
                <div className={`commonForm ${styleClasses.searchField}`}>
                  {/* 플레이리스트 URL 입력 */}
                  <div className="formRow">
                    <div className={`fieldBox ${ unreleasedYouTubeKeyword1 } ${styleClasses.inputField}`}>
                      <input
                        type="text"
                        ref={unreleasedPlaylistRef}
                        placeholder="플레이리스트 URL 입력"
                        value={playlistUrl}
                        onChange={(e) => { setPlaylistUrl(e.target.value); e.target.value !== '' && setUnreleasedYouTubeKeyword1(''); } }
                      />
                      <div className="fieldError">
                        <p>플레이리스트 URL을 입력하세요.</p>
                      </div>
                    </div>
                    <div className={`commonButton ${styleClasses.searchButton}`}>
                      <button
                        className="black"
                        onClick={ () => fetchUnreleasedAlbumsFromYouTube(1) }
                        disabled={loadingUnreleasedYouTube1}
                      >
                        <div className="commonIcon mobile">
                          <i className="searchWhite w24"></i>
                        </div>
                        <div className={`buttonLoading ${loadingUnreleasedYouTube1 && "active"}`}>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </button>
                    </div>
                  </div>
                  {/* 동영상 URL 입력 */}
                  <div className="formRow">
                    <div className={`fieldBox ${ unreleasedYouTubeKeyword2 } ${styleClasses.inputField}`}>
                      <input
                        type="text"
                        ref={unreleasedVideoRef}
                        placeholder="동영상 URL 입력"
                        value={videoUrl}
                        onChange={(e) => { setVideoUrl(e.target.value); e.target.value !== '' && setUnreleasedYouTubeKeyword2(''); } }
                      />
                      <div className="fieldError">
                        <p>동영상 URL을 입력하세요.</p>
                      </div>
                    </div>
                    <div className={`commonButton ${styleClasses.searchButton}`}>
                      <button
                        className="black"
                        onClick={ () => fetchUnreleasedAlbumsFromYouTube(2) }
                        disabled={loadingUnreleasedYouTube2}
                      >
                        <div className="commonIcon mobile">
                          <i className="searchWhite w24"></i>
                        </div>
                        <div className={`buttonLoading ${loadingUnreleasedYouTube2 && "active"}`}>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {isUnreleased && (
              <div className={`${styleClasses.searchBox} ${checkedSoundCloud ? styleClasses.active : ''}`}>
                <div className={styleClasses.description}>
                  <h2>사운드클라우드 앨범 가져오기</h2>
                  <p>사운드클라우드 사용자 URL을 입력하면, 해당 아티스트의 모든 플레이리스트 및 트랙들을 가져옵니다.</p>
                  <p>예) https://soundcloud.com/[사용자명]</p>
                </div>
                <div className={`commonForm ${styleClasses.searchField}`}>
                  <div className="formRow">
                    <div className={`fieldBox ${ soundCloudKeyword } ${styleClasses.inputField}`}>
                      <input
                        type="text"
                        ref={soundCloudRef}
                        placeholder="사운드클라우드 사용자 URL 입력"
                        value={soundCloudUrl}
                        onChange={(e) => {setSoundCloudUrl(e.target.value); e.target.value !== '' && setSoundCloudKeyword(''); }}
                      />
                    <div className="fieldError">
                      <p>사운드클라우드 사용자 URL을 입력하세요.</p>
                    </div>
                  </div>
                  <div className={`commonButton ${ styleClasses.searchButton }`}>
                    <button className="black" onClick={ fetchAlbumsFromSoundCloud } disabled={loading}>
                      <div className="commonIcon mobile">
                        <i className="searchWhite w24"></i>
                      </div>
                      <div className={`buttonLoading ${ loadingSoundCloud && 'active' }`}>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            )}

            <div className={`${ styleClasses.albumList } ${ showAlbumList ? styleClasses.active : '' }`}>
            {
              albums.length > 0
              ?
              (
                <>
                {
                  albums.map((album) => (
                    <div key={album.id} className={ styleClasses.albumCard }>
                      <div className={ styleClasses.checkBox }>
                        <div className="commonForm">
                          <div className="formRow">
                            <div className="fieldBox">
                              <input type="checkbox" name="eachAlbum" onChange={ (e) => checkAlbum(e.target.checked, album) } />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        {/* 앨범 정보 (썸네일 + 앨범명 + 발매일) */}
                        <div className={styleClasses.albumHeader}>
                          <div className={ styleClasses.imageBox }>
                            <img src={album.cover} alt="앨범 커버" />
                          </div>
                          <div className={ styleClasses.infoBox }>
                            <p>{ album.title }</p>
                            <p>{ album.year }</p>
                            <p>{ album.artist }</p>
                            {album.description && (<p>{album.description}</p>)}
                          </div>
                        </div>
                        {/* 트랙 리스트 */}
                        <div className={ styleClasses.trackList }>
                          {album.tracks.map((track) => (
                            <div key={track.id} className={styleClasses.trackItem}>
                              <a href={track.link} target="_blank" rel="noopener noreferrer">
                                🎵 {track.title}
                              </a>
                              {track.credits.length > 0 && <p>크레딧 : {track.credits.join(", ")}</p>}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))
                }
                  
                </>
              )
              :
              (
                <p className={ styleClasses.noResults }>검색 결과가 없습니다.</p>
              )
            }
            </div>
          </div>
          {
            albums.length > 0
            &&
            (
              <div className={ styleClasses.footer }>
                {
                  showProgress
                  ?
                  (
                    <div className={ styleClasses.progressBarDiv }>
                      <div className={ styleClasses.progressBar }>
                        <div className={ styleClasses.progress }>
                          <div className={ styleClasses.inProgress } style={{ width: `${ progress }%` }}></div>
                          <div className={ styleClasses.percent}>
                            <span>{`${ progress }%`}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                  :
                  null
                }
                <div className="commonForm">
                  <div className="formRow">
                    <div className="fieldBox checkBox">
                      <div className="eachBox">
                        <input type="checkbox" id="checkAllAlbums" onChange={ (e) => checkAllAlbums(e.target.checked) } />
                        <label htmlFor="checkAllAlbums">모든 앨범 선택</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="commonButton">
                  <button className="black" onClick={ handleAddAlbum } disabled={ loading }>
                    아카이브에 추가
                    <div className={`buttonLoading ${ loading && 'active' }`}>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </button>
                </div>
                <p className={ styleClasses.fieldDescription }>· 앨범이 많을수록 추가에 시간이 걸립니다.</p>
              </div>
            )
          }
        </div>
      </div>
      <Popup open={ openInnerPopup } setOpenPopup={ setOpenInnerPopup } title={ innerPopupTitle } text={ innerPopupText } buttonText='' buttonFunction='' buttonLoading='' />
    </>
  );
}

export default ImportAlbumPopup;